module.exports = __webpack_public_path__ + "img/magnetism-mobile.a90cd8a4.jpg";